import React from 'react';
import { motion } from 'framer-motion'; // <--- ADD THIS LINE
import { CheckCircle } from 'lucide-react';
import DonateBtn from './DonateBtn';

const Card = ({ title, price, features, color }) => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true }}
    className={`p-8 rounded-3xl bg-slate-800 border border-white/5 shadow-2xl transition-transform hover:-translate-y-2 flex flex-col h-full`}
  >
    <div className={`w-12 h-1 mb-6 rounded-full ${color}`}></div>
    <h3 className="text-2xl font-bold mb-2 text-white">{title}</h3>
    <div className="text-4xl font-black mb-6 text-white">
      ${price}
      <span className="text-sm font-normal text-slate-400">/mo</span>
    </div>
    
    <ul className="space-y-4 mb-10 flex-grow">
      {features.map((f, i) => (
        <li key={i} className="flex items-center gap-3 text-slate-300 text-sm">
          <CheckCircle size={18} className="text-gh-orange shrink-0" /> {f}
        </li>
      ))}
    </ul>

    <DonateBtn 
      className="w-full !rounded-xl !py-4 !bg-gh-blue hover:!bg-gh-orange !shadow-lg transition-all duration-300" 
    />
  </motion.div>
);

export default function SponsorCards() {
  return (
    <section className="bg-slate-900 py-24 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          {/* Now 'motion' is defined and will work perfectly */}
          <motion.span 
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            className="text-gh-orange font-black tracking-[0.3em] uppercase text-xs"
          >
            Choose Your Level of Support
          </motion.span>
          <h2 className="text-3xl md:text-5xl font-bold text-white mt-4 tracking-tight">
            Our Sponsorship <span className="text-gh-orange">Tiers</span>
          </h2>
        </div>
        
        <div className="grid md:grid-cols-3 gap-8">
          <Card 
            title="Basic Needs" 
            price="35" 
            color="bg-blue-400"
            features={["Nutritious Meals", "Safe Housing", "Clean Clothing"]} 
          />
          <Card 
            title="Full Education" 
            price="50" 
            color="bg-gh-orange"
            features={["School Tuition", "Books & Uniforms", "Vocational Training"]} 
          />
          <Card 
            title="Medical Hero" 
            price="100" 
            color="bg-gh-blue"
            features={["Physical Therapy", "Specialist Doctors", "Medication Support"]} 
          />
        </div>
      </div>
    </section>
  );
}